(() => {
  if (window.manickenB2bLightbox) return;
  window.manickenB2bLightbox = true;
  let activeDialog, links = [], index = 0, opener, previousOverflow, start;
  const bound = new WeakSet();
  const render = () => {
    const link = links[index];
    const img = activeDialog.querySelector('[data-b2b-large]');
    img.src = link.href;
    img.alt = link.dataset.caption || link.querySelector('img')?.alt || '';
    activeDialog.querySelector('[data-b2b-caption]').textContent = img.alt;
    activeDialog.querySelector('[data-b2b-counter]').textContent = `${index + 1} / ${links.length}`;
    activeDialog.querySelectorAll('[data-b2b-prev],[data-b2b-next]').forEach(button => { button.disabled = links.length < 2; });
  };
  const move = delta => { index = (index + delta + links.length) % links.length; render(); };
  const restore = () => {
    document.body.style.overflow = previousOverflow ?? '';
    if (opener?.isConnected) opener.focus({ preventScroll: true });
    activeDialog = null;
    start = null;
  };
  const bind = dialog => {
    if (bound.has(dialog)) return;
    bound.add(dialog);
    dialog.querySelector('[data-b2b-close]').addEventListener('click', () => dialog.close());
    dialog.querySelector('[data-b2b-prev]').addEventListener('click', () => move(-1));
    dialog.querySelector('[data-b2b-next]').addEventListener('click', () => move(1));
    dialog.addEventListener('close', restore);
    dialog.addEventListener('keydown', event => {
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault(); move(event.key === 'ArrowLeft' ? -1 : 1);
      }
    });
    dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
    const frame = dialog.querySelector('[data-b2b-large]').parentElement;
    frame.addEventListener('pointerdown', event => {
      if (event.pointerType !== 'touch') return;
      start = event.isPrimary ? { x: event.clientX, y: event.clientY, id: event.pointerId } : null;
    });
    frame.addEventListener('pointerup', event => {
      if (!start || event.pointerId !== start.id) return;
      const dx = event.clientX - start.x, dy = event.clientY - start.y;
      start = null;
      if (Math.abs(dx) > 50 && Math.abs(dy) < 70) move(dx < 0 ? 1 : -1);
    });
    frame.addEventListener('pointercancel', () => { start = null; });
  };
  document.addEventListener('click', event => {
    const link = event.target.closest?.('[data-b2b-image]');
    if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button > 0) return;
    const dialog = document.querySelector('[data-b2b-dialog]');
    if (!dialog?.showModal) return;
    event.preventDefault();
    links = [...link.closest('[data-b2b-gallery]').querySelectorAll('[data-b2b-image]')];
    index = links.indexOf(link);
    opener = link;
    activeDialog = dialog;
    previousOverflow = document.body.style.overflow;
    bind(dialog);
    render();
    dialog.showModal();
    document.body.style.overflow = 'hidden';
    dialog.querySelector('[data-b2b-close]').focus();
  });
  document.addEventListener('shopify:section:unload', event => {
    if (activeDialog && event.target.contains(activeDialog)) { activeDialog.close(); restore(); }
  });
})();
